import { OnboardingComplete } from "@/components/Elemnt/Onboarding/OnboardingComplete";
import { useParams } from "react-router";

const OnboardingCompletePage = () => {
  const { appToken = "" } = useParams();
  return <OnboardingComplete appToken={appToken} />;
};

export default OnboardingCompletePage;
